<template>
  <v-snackbar
    v-model="snackbar"
    :class="[
      { 'v-snack--left-position': mainMenuIsOpen && hasNavbarVisible },
      { 'v-snack--left-position-alt': !mainMenuIsOpen && hasNavbarVisible }
    ]"
    :timeout="props.timeout"
    :color="props.color || 'white'"
    :value="snackbar"
    fixed
    left
    bottom
  >
    <span v-if="props.message" v-html="props.message" class="v-snack__text" />
    <v-btn icon x-small @click="snackbar = false">
      <v-icon color="white">close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'Snackbar',
  computed: {
    ...mapState({
      props: ({ snackbar }) => snackbar,
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen
    }),

    snackbar: {
      set () {
        this.clearAlert()
      },
      get () {
        return this.props.isVisible
      }
    },

    hasNavbarVisible () {
      return this.$route.meta.menu
    }
  },
  methods: {
    ...mapActions({
      clearAlert: 'snackbar/clear'
    })
  }
}
</script>

<style lang="scss">
.v-snack {
  position: relative;

  .v-btn {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
  }
}

.v-snack__content {
  padding: 14px 34px 14px 16px;
}

.v-sheet.v-snack__wrapper:not(.v-sheet--outlined) {
  box-shadow: none;
}

.v-snack--left-position {

  @media (min-width: 1200px) {
    left: $menu-width;
  }
}

.v-snack--left-position-alt {

  @media (min-width: 1200px) {
    left: 73px;
  }
}

.v-snack__text {
  font-size: $base-font-size;
}
</style>
